import VerticalPage from "../components/VerticalPage";
import { usePageTitle } from "../hooks/usePageTitle";

const CONFIG = {
  verticalSlug: "cleaning",
  eyebrow: "Built for Residential & Commercial Cleaning",
  headline: "Close cleaning jobs faster.",
  headlineHighlight: "Get 5-star reviews automatically.",
  sub: "CleanBid sends quotes via SMS the moment a customer reaches out, follows up until they book, and requests a review the second the job is done — so you can focus on the clean, not the paperwork.",
  quoteCard: {
    service: "Home Deep Clean",
    size: "2,400 sqft",
    price: "$310",
  },
  problems: [
    {
      title: "Slow Quotes",
      body: "Cleaning customers reach out to 3 companies and book the first one that responds. If you're still calling back hours later, you've already lost the job.",
    },
    {
      title: "No Follow-Up",
      body: "Most cleaning estimates need 2–3 follow-ups before they convert. Most cleaners send one and never follow up again. That's where jobs go quiet.",
    },
    {
      title: "Missing Reviews",
      body: "You do exceptional work. Your Google profile doesn't show it — because satisfied clients need to be asked. Once. At the right moment.",
    },
  ],
  features: [
    {
      badge: "SMS Quoting",
      headline: "Send a cleaning quote before your competitor answers the phone.",
      body: "Build and send a professional quote in 60 seconds via SMS. Customers get a real price on their phone — and can accept with one tap, before they even talk to the next company.",
    },
    {
      badge: "Follow-Up Automation",
      headline: "When a lead goes quiet, CleanBid keeps the conversation alive.",
      body: "Day 1. Day 3. Day 5. Automatic. Timed. Professional. So you never lose a cleaning job to silence while you're on the job.",
    },
    {
      badge: "Review Automation",
      headline: "The moment you finish the clean, the review request goes out.",
      body: "No awkward ask. No forgetting. CleanBid sends the request automatically when you mark the job complete — while the experience is still fresh.",
    },
  ],
  testimonial: {
    quote: "We went from 12 Google reviews to 47 in two months. CleanBid just asked at the right time.",
    name: "Maria S.",
    role: "Residential Cleaning",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=60&h=60&fit=crop&crop=face",
  },
  ctaBadge: "Ready to run a tighter cleaning business?",
  heroImage: {
    src: "https://cdn.searchlegends.com/kro-website/cleaning-services.jpg",
    alt: "Professional house cleaning technician",
  },
};

export default function ForCleaningPage() {
  usePageTitle("CleanBid for Cleaning Businesses");
  return <VerticalPage config={CONFIG} />;
}
